/**
 * Фирменный лоадер Skrezo (как в кабинете клиники): плитка «S» + кольцо.
 * Для областей загрузки кладётся поверх Skeleton-подложки по центру:
 *   <div className="relative">…скелетоны…<Loader className="absolute inset-0" /></div>
 */

import {cn} from '@lib/utils';

type LoaderProps = {
  /** Подпись под лоадером («Загружаем клиентов…») */
  label?: string;
  className?: string;
};

export const Loader = ({label, className}: LoaderProps) => (
  <div className={cn('flex flex-col items-center justify-center gap-4', className)} role="status">
    <div className="relative flex size-16 items-center justify-center">
      <span
        aria-hidden
        className="absolute -inset-1 animate-spin rounded-full border-2 border-skr-line border-t-primary [animation-duration:900ms] motion-reduce:animate-none"
      />
      <span className="flex size-11 items-center justify-center rounded-[14px] bg-foreground text-lg font-bold text-background">
        S
      </span>
    </div>
    {label !== undefined && <span className="text-sm text-skr-label">{label}</span>}
  </div>
);
